import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import { ArrowLeft, Send,Play } from 'lucide-react';
import "../../../../assets/css/screens/serviceprovider/dashboard/helpandsupport/WorkerChat.css";
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';

const WorkerChat = () => {
  const { baseUrl, authToken,baseUrlForFile } = useContext(AppContext);
  const { conversationId }     = useParams();
  const location               = useLocation();
  const navigate               = useNavigate();

  const ticketDescription = location.state?.description;

  const [messages, setMessages] = useState([]);
  const [type,     setType]     = useState('');
  const [loading,  setLoading]  = useState(false);

  const [customerMedia, setCustomerMedia] = useState([]);
const [workerProofs, setWorkerProofs] = useState([]);

const [previewImage, setPreviewImage] = useState(null);
const [previewVideo, setPreviewVideo] = useState(null);

  const bottomRef = useRef(null);

  // =========================
  // SEND MESSAGE
  // =========================
// const sendMessage = async () => {
//   if (!type.trim() || !conversationId) return;

//   const formData = new FormData();
//   formData.append('whconversation_id', conversationId);
//   formData.append('message', type);
//   formData.append('type', 'text');

//   setType('');

//   try {
//     await axios.post(`${baseUrl}/worker/createchat`, formData, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('authToken')}`,
//       },
//     });

//     fetchChats(); // only this
//   } catch (err) {
//     console.log(err.response?.data || err.message);
//   }
// };
const sendMessage = async () => {

  if (!type.trim() || !conversationId) return;
    const formData = new FormData();
  formData.append("whconversation_id", Number(conversationId));
  formData.append("message", type.trim());
  formData.append("sender", "worker");
  formData.append("type", "text");

  try {

    console.log("SENDING:", type);

    const response = await axios.post(`${baseUrl}/worker/createchat`, formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "Content-Type": "multipart/form-data"
        }
      });

    console.log("RESPONSE:", response.data);

    setMessages(prev => [...prev, response.data.chat]);

    setType('');

  } catch (err) {

    console.log("ERROR:", err.response?.data || err.message);

  }
};
  const handleKey = (e) => {
    if (e.key === 'Enter') sendMessage();
  };

  
  // =========================
  // VIEW CHATS
  // =========================
const fetchChats = () => {
  const auth = authToken || localStorage.getItem('authToken');

  axios.get(`${baseUrl}/worker/receviechat`, {
    headers: { Authorization: `Bearer ${auth}` },
    params: { whconversation_id: conversationId },
  })
 .then(res => {
  const chats = res.data.messages || [];

 

  setMessages(chats);

  // ⭐ ADD THIS
  setCustomerMedia(res.data.customerMedia || []);
  setWorkerProofs(res.data.workerProofs || []);
})
  .catch(console.log);
};

  // Scroll to bottom on new message
useEffect(() => {
  console.log("Conversation ID:", conversationId);

  if (conversationId) {
    fetchChats();
  }
}, [conversationId]);

  return (
    <>
      <WorkerNavbar />

      <div className="wc-root">

        {/* HEADER */}
        <div className="wc-header">
          <button className="wc-header__back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>
          <h3 className="wc-header__title">Chat</h3>
        </div>

        {/* MESSAGES */}
       <div className="wc-messages">

        {ticketDescription && (
    <div className="cc-ticket-box">
      🟡 Ticket: {ticketDescription}
    </div>
  )}

        {/* MEDIA SECTION */}
<div className="wc-dispute-media">

  {customerMedia.length > 0 && (
    <>
      <h5>Customer Media</h5>

      <div className="wc-media-grid">
        {customerMedia.map((media) => {
          const ext = media.file?.split('.').pop()?.toLowerCase();
          const isVideo = ["mp4", "webm", "mov", "avi"].includes(ext);

          return isVideo ? (
            <div
  key={media.id}
  className="wc-video-thumb"
  onClick={() => setPreviewVideo(`${baseUrlForFile}/${media.file}`)}
>
  <video
    src={`${baseUrlForFile}/${media.file}`}
  />

  <div className="wc-play-icon">
    <Play size={28} fill="white" />
  </div>
</div>
          ) : (
            <img
              key={media.id}
              src={`${baseUrlForFile}/${media.file}`}
              onClick={() => setPreviewImage(`${baseUrlForFile}/${media.file}`)}
            />
          );
        })}
      </div>
    </>
  )}

  {workerProofs.length > 0 && (
    <>
      <h5>Worker Proofs</h5>

      <div className="wc-media-grid">
        {workerProofs.map((media) => {
          const ext = media.file?.split('.').pop()?.toLowerCase();
          const isVideo = ["mp4", "webm", "mov", "avi"].includes(ext);

          return isVideo ? (
            <div
  key={media.id}
  className="wc-video-thumb"
  onClick={() => setPreviewVideo(`${baseUrlForFile}/${media.file}`)}
>
  <video
    src={`${baseUrlForFile}/${media.file}`}
  />

  <div className="wc-play-icon">
    <Play size={28} fill="white" />
  </div>
</div>
          ) : (
            <img
              key={media.id}
              src={`${baseUrlForFile}/${media.file}`}
              onClick={() => setPreviewImage(`${baseUrlForFile}/${media.file}`)}
            />
          );
        })}
      </div>
    </>
  )}

</div>
 {messages.map((msg, i) => {
  if (!msg) return null;   // ✅ CRASH STOP

  const isWorker = msg.sender === 'worker';
  const isAdmin  = msg.sender === 'admin';
  const isSystem = msg.sender === 'system';

  return (
    <div
      key={msg.id || i}
      className={`wc-bubble 
        ${isWorker ? 'wc-right' : ''} 
        ${isAdmin ? 'wc-admin' : ''} 
        ${isSystem ? 'wc-system' : ''} 
        ${!isWorker && !isAdmin && !isSystem ? 'wc-left' : ''}
      `}
    >
      {!isSystem && (
        <small className="wc-sender">
          {msg.sender === 'worker'
            ? 'You'
            : msg.sender === 'admin'
            ? 'Admin'
            : 'Customer'}
        </small>
      )}

      <p>{msg.message}</p>
    </div>
  );
})}

  <div ref={bottomRef} />
</div>

        {/* INPUT */}
        <div className="wc-input">
          <input
            value={type}
            onChange={e => setType(e.target.value)}
            onKeyDown={handleKey}
            placeholder="Type message..."
          />
          <button onClick={sendMessage}>
            <Send size={18} />
          </button>
        </div>
        {previewImage && (
  <div className="wc-media-modal" onClick={() => setPreviewImage(null)}>
    <button className="wc-media-close" onClick={() => setPreviewImage(null)}>✖</button>
    <img src={previewImage} />
  </div>
)}

{previewVideo && (
  <div className="wc-media-modal" onClick={() => setPreviewVideo(null)}>
    <button className="wc-media-close" onClick={() => setPreviewVideo(null)}>✖</button>
    <video controls autoPlay>
      <source src={previewVideo} />
    </video>
  </div>
)}

      </div>
    </>
  );
};

export default WorkerChat;